export const ONBOARDING_CONNECTED_APP_VISIBLE_LIMIT = 8;

export interface ConnectedAppsDisplayState {
  visibleTools: string[];
  overflowTools: string[];
}

export const resolveConnectedAppsDisplayState = (
  connectedTools: readonly string[],
): ConnectedAppsDisplayState => ({
  visibleTools: connectedTools.slice(0, ONBOARDING_CONNECTED_APP_VISIBLE_LIMIT),
  overflowTools: connectedTools.slice(ONBOARDING_CONNECTED_APP_VISIBLE_LIMIT),
});
